export const extractMapConfigForLayer = (mapConfig, featureId) => {
    if (featureId !== undefined && mapConfig?.layers) {
        return mapConfig.layers.find(layer => layer.assetType === featureId.split('.')[0]);
    }
};
